import { Close } from "@mui/icons-material";
import { ReactNode } from "react";

export type ModalProps = {
  children: ReactNode;
  onClose: () => void;
  title: string;
}

const Modal = ({ children, title, onClose }: ModalProps): JSX.Element => {
  {/* Le z-index est à éviter, mais impossible de faire autrement avec les menus de mui */}
  return  <div className='fixed top-[0] left-[0] z-[20] h-full w-full flex justify-center items-center bg-black bg-opacity-30'>
            <div className='flex flex-col p-3w pt-2w gap-2w w-fit rounded-lg bg-white bg-opacity-100'>
              <div className='flex items-center gap-2w w-full'>
                <h1 className='text-header6'>{title}</h1>
                <Close className='ml-auto text-classic-red-main cursor-pointer' onClick={onClose} data-testid='close-button' />
              </div>
              {children}
            </div>
          </div>
}

export default Modal;